module.exports = __webpack_public_path__ + "static/media/120681640762230download.d43c901a.jpg";